import application from "@homer.core/application";
import scheduler from "@homer.core/scheduler";
import whenImages from "@homer.core/when.images";

const isSupported = "serviceWorker" in navigator;

if (isSupported) {
    const processLocales = (context) => {
        if (!context) {
            return;
        }

        context.postMessage(JSON.stringify({ type: "LOCALES", data: application.locales }));
    };

    scheduler.yield.low(whenImages).then(async () => {
        try {
            await navigator.serviceWorker.register(`/worker.js?module.version=${application.version}`).then((registration) => {
                registration.onupdatefound = () => {
                    processLocales(registration.installing);
                };

                processLocales(registration.active);
            });
        } catch (error) {
            // purposely ignore as this can actually happen
        }
    });
}

export default isSupported;
